import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../library/button/button';

import { TREADWELL_PRODUCTS_DISPLAY_TYPES } from '../../shared/constants/products';

import './treadwell-see-all-button.scss';

function TreadwellSeeAllButton(props) {
  const { className, onClick, treadwellProductsDisplayType } = props;

  if (
    window.isPreRendering ||
    treadwellProductsDisplayType !== TREADWELL_PRODUCTS_DISPLAY_TYPES.SHOW_THREE
  ) {
    return null;
  }

  return (
    <div className={className} styleName="wrapper">
      <Button isFullWidth isSecondary onClick={onClick}>
        See All Recommended Tires
      </Button>
    </div>
  );
}

TreadwellSeeAllButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  treadwellProductsDisplayType: PropTypes.string.isRequired
};

export default TreadwellSeeAllButton;
